import detailForm from './detailForm';
import educationDetailTable from './educationDetailTable';
import educationForm from './educationForm';
import educationView from './educationView';
export default {
  layout: 'education-layout',
  addBtn: 'add-btn',
  grid: 'education-grid',
  educationView,
  educationDetailTable,
  educationForm,
  detailForm,
};
